import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { Modal, ModalBody, ModalFooter, Button, Input, Form, Select } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Helpers
import { getNetworkTypes } from 'Core/data/Helpers';

//Actions 
import {
    clearRedux,
    partNumberCreateRequest,
    partNumberUpdateRequest,
    partNumberGetRequest,
    searchEntityRequest,
} from 'Redux/actions';

const CreateEditPartNumber = (props) => {
    const { manufacturer, tableRef } = props;
    const { messages } = useIntl();
    const formRef = useRef();
    const dispatch = useDispatch();

    //Local States
    const [partNumber, setPartNumber] = useState("");
    const [partNumberTitle, setPartNumberTitle] = useState("");
    const [deviceModel, setDeviceModel] = useState(null);
    const [newwork, setNewwork] = useState(null);

    //Redux States
    const { openModal, loading, create, update, current, partnumber } = useSelector(state => state.createEditPartNumberRedux);
    const deviceModels = useSelector(state => state.generalRedux.deviceModels);
    const user = useSelector(state => state.securityRedux.user);

    const closeModal = () => {
        dispatch(clearRedux("CREATE_EDIT_PARTNUMBERS"));
        setPartNumber("");
        setDeviceModel(null);
        setNewwork(null);
        setPartNumberTitle("");
    }

    const applyChanges = () => {
        let payload = {
            partNumber,
            deviceModelId: deviceModel?.id,
            network: newwork?.id
        }
        if (current) {
            payload.id = current?.id
            dispatch(partNumberUpdateRequest(payload))
        } else dispatch(partNumberCreateRequest(payload));
    }

    useEffect(() => {
        dispatch(searchEntityRequest({ key: "deviceModels" }));
        if (openModal && current) {
            dispatch(partNumberGetRequest(current?.id))
        }
    }, [openModal])

    useEffect(() => {
        if (create?.id) {
            closeModal();
            tableRef && tableRef?.current?.getData();
            dispatch(clearRedux("CREATE_EDIT_PARTNUMBERS", { create: null }));
            NotificationManager.success(
                messages['create_partnumber_create_success_message'],
                messages['create_partnumber_create_title'],
                3000
            );
        }
        if (update?.id) {
            closeModal();
            tableRef && tableRef?.current?.getData();
            dispatch(clearRedux("CREATE_EDIT_PARTNUMBERS", { update: null }));
            NotificationManager.success(
                messages['create_partnumber_update_success_message'],
                messages['create_partnumber_edit_title'],
                3000
            );
        }
        if (partnumber) {
            partnumber?.partNumber && setPartNumber(partnumber?.partNumber);
            setPartNumberTitle(partnumber?.partNumber);
            let currentDeviceModel = deviceModels?.find((item) => item?.id === partnumber?.deviceModel?.id)
            let newDevicemodel = currentDeviceModel ? { ...currentDeviceModel, label: `${currentDeviceModel?.name} ${currentDeviceModel?.product ? `- ${currentDeviceModel?.product}` : ''}` } : {}
            partnumber?.deviceModel && setDeviceModel(newDevicemodel);
            partnumber?.network && setNewwork({ id: partnumber.network, name: partnumber.network })
            dispatch(clearRedux("CREATE_EDIT_PARTNUMBERS", { partnumber: null }))
        }
    }, [create, update, partnumber])

    return (
        <Modal
            open={openModal}
            title={current ? `${messages['create_partnumber_edit_title']} ${partNumberTitle ? ` (${partNumberTitle})` : ''}` : messages['create_partnumber_create_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => applyChanges()}
                    >
                        <div className="manufacturer-input">
                            <Input
                                label={messages['create_partnumber_manufacturer']}
                                placeholder={messages['create_partnumber_manufacturer']}
                                value={manufacturer?.name || ""}
                                onChange={() => { }}
                                disabled
                            />
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Input
                                label={messages['create_partnumber_part_number']}
                                placeholder={messages['create_partnumber_part_number']}
                                value={partNumber}
                                onChange={(value) => setPartNumber(value)}
                                required
                                requiredMessage={messages["common_field_required"]}
                            />
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Select
                                id="device-model-list"
                                label={messages['create_partnumber_device_model']}
                                placeholder={messages['create_partnumber_device_model']}
                                options={deviceModels ? deviceModels.filter((item) => item?.manufacturerId === manufacturer?.id).map((item) => ({ ...item, label: `${item?.name} ${item?.product ? `- ${item?.product}` : ''}` })) : []}
                                onChange={(value) => setDeviceModel(value)}
                                value={deviceModel}
                                required
                                requiredMessage={messages["common_field_required"]}
                                textField="label"
                                valueField="id"
                                isClearable
                            />
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Select
                                id="network-list"
                                label={messages['create_partnumber_network']}
                                placeholder={messages['create_partnumber_network']}
                                options={getNetworkTypes() || []}
                                onChange={(value) => setNewwork(value)}
                                value={newwork}
                                textField="name"
                                valueField="id"
                                isClearable
                                required
                                requiredMessage={messages["common_field_required"]}
                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => formRef?.current?.submit()}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CreateEditPartNumber;